export enum AuctionTypeSearchEnum {
  Bidding = 'bidding',
  BuyNow = 'buyNow',
  PriceProposal = 'priceProposal',
  None = 'none'
}
